export enum StageCode {
  DontApply = "06",
}
